module.exports = __webpack_public_path__ + "static/img/center.4db4207.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/center.jpg
// module id = aU5W
// module chunks = 1